import React__default from 'react';
import { d as darken } from './darken-303c3324.js';
import _s, { css } from 'styled-components';
import { D as Downshift$1 } from './downshift.esm-ac8008a7.js';
import { n as noop } from './noop-fc861ff1.js';
import Box from './Box.js';
import LoadingIndicator from './LoadingIndicator.js';
import Typography from './Typography.js';
import './_commonjsHelpers-357b3b4e.js';
import './index-5fd269e1.js';
import './index-48edd52c.js';
import './index-a67b9a05.js';
import './tslib.es6-8b55ad02.js';
import './useTheme.js';
import './core.esm-901288dd.js';
import './inheritsLoose-6f2ea841.js';

const AutocompleteEmptyState = ({
  descriptionText,
  testID,
  titleText
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    testID: testID,
    margin: "xLarge"
  }, /*#__PURE__*/React__default.createElement(Box, {
    marginBottom: "xSmall"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    center: true,
    color: "primary",
    variant: "headline-3"
  }, titleText)), /*#__PURE__*/React__default.createElement(Box, {
    marginBottom: "base"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    center: true,
    color: "primary",
    variant: "body-1"
  }, descriptionText)));
};

/* eslint-disable react/jsx-props-no-spreading */
const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
function AutoComplete({
  data,
  customEmptyState,
  emptyState = {
    descriptionText: 'No results were found',
    titleText: "We're not available here"
  },
  listFooterComponent,
  loading,
  loadingTestID,
  onInputValueChange,
  onOuterPress,
  onSelect = noop,
  open,
  renderInput,
  selectedItem,
  testID,
  inputValue
}) {
  const handleChange = event => {
    onInputValueChange(event.currentTarget.value);
  };
  const renderEmptyContent = () => {
    if (customEmptyState) return customEmptyState;
    return /*#__PURE__*/React__default.createElement(AutocompleteEmptyState, {
      descriptionText: emptyState.descriptionText,
      titleText: emptyState.titleText,
      testID: emptyState.testID
    });
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    testID: testID,
    width: "100%"
  }, /*#__PURE__*/React__default.createElement(Downshift$1, {
    inputValue: inputValue,
    isOpen: open,
    itemToString: item => item ? item.value : '',
    onOuterClick: onOuterPress,
    onSelect: onSelect,
    selectedItem: selectedItem
  }, ({
    getInputProps,
    getItemProps,
    getMenuProps,
    getRootProps,
    highlightedIndex,
    isOpen
  }) => {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", Object.assign({}, getRootProps(undefined, {
      suppressRefError: true
    })), renderInput(Object.assign(Object.assign({}, getInputProps()), {
      onChange: handleChange
    }))), isOpen && /*#__PURE__*/React__default.createElement(Box, Object.assign({}, getMenuProps(), {
      backgroundColor: "transparent",
      paddingTop: "tiny",
      position: "absolute",
      zIndex: 1
    }), /*#__PURE__*/React__default.createElement(List, {
      hasFooter: !!listFooterComponent
    }, loading ? /*#__PURE__*/React__default.createElement(Box, {
      alignItems: "center",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      marginVertical: "xxxLarge"
    }, /*#__PURE__*/React__default.createElement(LoadingIndicator, {
      testID: loadingTestID
    })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, data.length === 0 ? renderEmptyContent() : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, data.map((item, index) => /*#__PURE__*/React__default.createElement(Item, Object.assign({
      highlighted: highlightedIndex === index
    }, getItemProps({
      key: item.id,
      index,
      item
    })), /*#__PURE__*/React__default.createElement(Typography, {
      color: "primary",
      ellipsis: true,
      variant: "body-1"
    }, item.titleText), /*#__PURE__*/React__default.createElement(Typography, {
      color: "quaternary",
      ellipsis: true,
      variant: "body-2"
    }, item.subtitleText)))))), listFooterComponent && listFooterComponent()));
  }));
}
const List = styled.ul`
  ${({
  theme
}) => css(["background:", ";border-color:", ";border-style:solid;border-width:", "px;box-shadow:", ";list-style:none;max-height:360px;overflow-y:scroll;width:420px;z-index:1;"], theme.backgroundColors.primary, theme.borderColors.primary, theme.borderWidths.base, theme.boxShadows.base)}

  ${({
  theme,
  hasFooter
}) => !hasFooter ? css(["border-radius:", "px;"], theme.borderRadius.base) : css(["border-top-left-radius:", "px;border-top-right-radius:", "px;"], theme.borderRadius.base, theme.borderRadius.base)}

  li:first-child {
    ${({
  theme
}) => css(["padding-top:", "px;"], theme.spacings.xSmall)}
  }

  li:last-child {
    ${({
  theme
}) => css(["padding-bottom:", "px;"], theme.spacings.xSmall)}
  }
`;
const Item = styled.li`
  cursor: pointer;

  ${({
  theme,
  highlighted
}) => css(["background:", ";padding:", "px ", "px;"], highlighted ? darken(0.05, theme.backgroundColors.primary) : theme.backgroundColors.primary, theme.spacings.tiny, theme.spacings.medium)}
`;

export { AutoComplete as default };
//# sourceMappingURL=AutoComplete.js.map
